import { render, staticRenderFns } from "./ReportSummary.vue?vue&type=template&id=3b142bf2&"
import script from "./ReportSummary.vue?vue&type=script&lang=ts&"
export * from "./ReportSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports